const getDeviceType = (): 'mobile' | 'tablet' | 'desktop' => {
    const screenWidth =
        window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    if (screenWidth < 768) return 'mobile';
    if (screenWidth < 1024) return 'tablet';
    return 'desktop';
};

export default getDeviceType;
